// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3WdCJ","form":"styles_form__1736l"};